import { render, staticRenderFns } from "./IssueReportDevelopmentNameIssueNoDeveloperUser.vue?vue&type=template&id=63b49188&scoped=true&"
import script from "./IssueReportDevelopmentNameIssueNoDeveloperUser.vue?vue&type=script&lang=js&"
export * from "./IssueReportDevelopmentNameIssueNoDeveloperUser.vue?vue&type=script&lang=js&"
import style0 from "./IssueReportDevelopmentNameIssueNoDeveloperUser.vue?vue&type=style&index=0&id=63b49188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b49188",
  null
  
)

export default component.exports